import {createEnvironmentSlice} from "@/data/create_environment_slice.js";

export const {merge, reducer, replace, update} = createEnvironmentSlice("ControlServer");
